import React, { useCallback, useState } from "react";
import classNames from "classnames";

import "./Intro.scss";

import AppLogo from "./assets/images/808303studio.svg";

interface IntroProps {
  isVisible: boolean;
  onDismiss: () => void;
}
export const Intro: React.FC<IntroProps> = ({ isVisible, onDismiss }) => {
  let [dismissed, setDismissed] = useState(false);
  let dismiss = useCallback(() => {
    setDismissed(true);
    setTimeout(() => onDismiss(), 1500);
  }, [onDismiss]);

  return (
    <div
      className={classNames("intro", { isVisible: !dismissed })}
      onClick={dismiss}
    >
      <div className="introContent">
        <img className="introLogo" src={AppLogo} alt="808303studio" />
        <div className="introText">
          <p>
            Yuri Suzuki, in collaboration with the Design Museum and Roland,
            presents a digital musical instrument emulating the sound of the
            original TR&#8209;808 drum machine and TB&#8209;303 bass
            synthesiser.
          </p>
          <p className="enterText enterText--mobile">Click to enter</p>
          <p className="enterText enterText--desktop">Click to enter</p>
        </div>
      </div>
    </div>
  );
};
